import type { TrackPlugin, Tracker } from '../../core';

export interface PageViewOptions {
  eventName?: string;
}

/**
 * 浏览器端自动 PageView 捕获插件
 */
export function browserPageViewPlugin(options?: PageViewOptions): TrackPlugin {
  const eventName = options?.eventName ?? 'page_view';

  return {
    name: 'hss-browser-page-view-plugin',

    init(tracker: Tracker) {
      if (typeof window === 'undefined') return;

      const triggerPageView = () => {
        try {
          tracker.track(eventName, {
            pageUrl: window.location.href,
            pagePath: window.location.pathname,
            pageTitle: document.title,
            referrer: document.referrer,
          });
        } catch {
          // 路由回调中的宿主属性读取失败时跳过本次采集。
        }
      };

      // 首次加载触发
      triggerPageView();

      // 监听浏览器路由前进/后退
      window.addEventListener('popstate', triggerPageView);

      // 拦截 SPA pushState 与 replaceState
      const originalPushState = history.pushState;
      history.pushState = function (...args) {
        originalPushState.apply(this, args);
        triggerPageView();
      };

      const originalReplaceState = history.replaceState;
      history.replaceState = function (...args) {
        originalReplaceState.apply(this, args);
        triggerPageView();
      };
    },
  };
}
